var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoSymbol(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    fill: "#E72F0D"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 20,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.75,
    cy: 24.76,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.25,
    cy: 24.76,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 20,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.25,
    cy: 15.24,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.75,
    cy: 15.24,
    r: 0.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    fill: "#E72F0D"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 20,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 29.53,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 29.53,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 20,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 10.47,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 10.47,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.93,
    cy: 24,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 28,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.07,
    cy: 24,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.07,
    cy: 16,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 12,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.93,
    cy: 16,
    r: 1
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#E72F0D"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 20,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.75,
    cy: 33.42,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.25,
    cy: 33.42,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 20,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.25,
    cy: 6.58,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.75,
    cy: 6.58,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.39,
    cy: 26,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 32,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.61,
    cy: 26,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.61,
    cy: 14,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 8,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.39,
    cy: 14,
    r: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSymbol);
export default __webpack_public_path__ + "static/media/logo-symbol.424cc7791cb2e25080cf5182de812f62.svg";
export { ForwardRef as ReactComponent };